import React from "react";
import { getIn } from "formik";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

function FormAutoComplete({ field, form, label, options = [], isRequired, isLoading, onValueChange, ...props }) {
    const errorText = getIn(form.touched, field.name) && getIn(form.errors, field.name);

    return (
        <FormControl fullWidth error={!!errorText}>
            {field.name && (
                <InputLabel sx={{ ml: -1.6, textTransform: "capitalize" }} shrink htmlFor={field.name}>
                    <Typography variant="body1">
                        {label}
                        {isRequired && (
                            <Typography variant="body1" color="error" component="span">
                                {" *"}
                            </Typography>
                        )}
                    </Typography>
                </InputLabel>
            )}

            <Autocomplete
                {...props}
                id={field.name}
                options={options}
                filterOptions={(x) => x}
                sx={{
					border: "0.5px solid #DC143C",
					borderRadius: "6px",
					mt: 2,
					"& fieldset": { border: "none" },
					"& .MuiOutlinedInput-root .MuiAutocomplete-input": { padding: "1px 0" }
				}}
                onChange={(_, newValue) => {

                    // Ensure the correct value is extracted
                    const selectedValue = newValue ? newValue.value : "";

                    // Update form field
                    form.setFieldValue(field.name, selectedValue);

                    // Call the callback function with selected value
                    if (onValueChange) {
                        onValueChange(selectedValue);
                    }
                }}
                getOptionLabel={(option) => option.label || ""}
                isOptionEqualToValue={(option, val) => option.value === val}
                renderOption={(props, option) => (
                    !isLoading ? (
                        <li {...props} key={option.value}>
                            <Typography variant="body1">{option.label}</Typography>
                        </li>
                    ) : (
                        <li>
                            <Typography variant="body1">...loading</Typography>
                        </li>
                    )
                )}
                renderInput={(params) => (
                    <TextField
                        // error={Boolean(errorText)}
                        // helperText={errorText}
                        label={undefined}
                        name={field.name}
                        {...params}
                    />
                )}
                value={options.find((option) => option.value === field.value) || null}
            />
               <Typography variant="body2" fontSize={"10px"} color="#DC143C" component="span">
                {errorText}
            </Typography>
        </FormControl>
    );
}

export { FormAutoComplete };
